module.exports = __webpack_public_path__ + "img/symbol_5.892ac9d8.png";